import { AdminPage } from './AdminPage';
import { UiFeatureLite } from '@/app/feature';
import { FeatureCodes } from '@ssar-app/domain';

export const adminFeature: UiFeatureLite = {
  isDisabled: false,
  code: FeatureCodes.Admin,
  rootComponent: <AdminPage />,
};
